import { defineQuery } from 'next-sanity'
import { copyBlockFields } from './copyBlock'
import { subjectSliderFields } from './subjectSlider'

export const fileContentFields = `
  _id,
  _type,
  title,
  showTitle,
  fileBackgroundColor,
  tabs[]{
    _type,
    title,
    content[]{
      _type,
      ...select(
        _type == "copy-block" => {
          ${copyBlockFields}
        },
        _type == "subject-slider" => {
          ${subjectSliderFields}
        }
      )
    }
  }
`

export const FILE_CONTENT_QUERY = defineQuery(/* groq */ `
  *[_type == "file-content"][0]{
    ${fileContentFields}
  }
`)
